module.exports = __webpack_public_path__ + "media/bootstrap-icons/aspect-ratio-db6f6e10.svg";